export async function sleep(timeoutInMilliseconds: number) {
  await new Promise((resolve) => setTimeout(resolve, timeoutInMilliseconds));
}
